import { gql } from '@apollo/client';

export const THEME_FRAGMENT = gql`
  fragment ThemeFragment on AppearanceTheme {
    id
    name
    mode
    isDefault
    assets {
      type
      downloadLink
      uploadLink {
        url
        token
      }
    }
    appearanceColors {
      theme
      primaryColor
      backgroundColor
      cardColor
      textFontColor
      headingFontColor
      iconColor
    }
    fonts {
      headingFont
      textFont
    }
  }
`;

export const GET_LSPRO_BRANDING_SETTINGS = gql`
  query GetLsproBrandingSettings($lsproId: ID!) {
    configuration {
      appearanceColors {
        theme
        primaryColor
        backgroundColor
        cardColor
        iconColor
        textFontColor
        headingFontColor
      }
    }
    lsproSettings(lsproId: $lsproId) {
      lsproId
      appearance {
        supportedFonts {
          id
          name
          isStandard
          asset {
            assetId
            downloadLink
            status {
              code
              error
            }
          }
        }
      }
      themes {
        ...ThemeFragment
      }
    }
  }
  ${THEME_FRAGMENT}
`;

export const CREATE_APPEARENCE_ASSET = gql`
  mutation CreateAppearanceAsset($input: CreateAppearanceAssetInput!) {
    createAppearanceAsset(input: $input) {
      ... on CreateAppearanceAssetSuccess {
        asset {
          type
          downloadLink
          uploadLink {
            url
            token
          }
        }
      }
      ... on CreateAppearanceAssetFailure {
        code
      }
    }
  }
`;

export const DELETE_APPEARENCE_ASSET = gql`
  mutation DeleteAppearanceAsset($input: DeleteAppearanceAssetInput!) {
    deleteAppearanceAsset(input: $input) {
      ... on DeleteAppearanceAssetSuccess {
        lsproId
      }
      ... on DeleteAppearanceAssetFailure {
        code
      }
    }
  }
`;

export const CREATE_LSPRO_CUSTOM_FONT = gql`
  mutation CreateLsproCustomFont($input: CreateFontInput!) {
    createFont(input: $input) {
      ... on CreateFontSuccess {
        fontId
        uploadLink {
          token
          url
        }
      }
      ... on CreateFontProblem {
        code
      }
    }
  }
`;

export const DELETE_LSPRO_CUSTOM_FONT = gql`
  mutation DeleteLsproCustomFont($input: DeleteFontInput!) {
    deleteFont(input: $input) {
      ... on DeleteFontSuccess {
        fontId
      }
      ... on DeleteFontProblem {
        code
      }
    }
  }
`;

export const UPDATE_LSPRO_CUSTOM_FONT = gql`
  mutation UpdateLsproCustomFont($input: UpdateAppearanceSettingsInput!) {
    updateAppearanceSettings(input: $input) {
      ... on UpdateAppearanceSettingsSuccess {
        appearanceSettings {
          supportedFonts {
            asset {
              assetId
              downloadLink
              status {
                code
                error
              }
            }
            id
            isStandard
            name
          }
        }
      }
    }
  }
`;

export const CREATE_THEME = gql`
  mutation CreateTheme($input: CreateThemeInput!) {
    createTheme(input: $input) {
      ... on CreateThemeSuccess {
        theme {
          ...ThemeFragment
        }
      }
      ... on CreateThemeFailure {
        code
      }
    }
  }
`;

export const UPDATE_THEME = gql`
  mutation UpdateTheme($input: UpdateThemeInput!) {
    updateTheme(input: $input) {
      ... on UpdateThemeSuccess {
        theme {
          ...ThemeFragment
        }
      }
      ... on UpdateThemeFailure {
        code
      }
    }
  }
`;

export const DELETE_THEME = gql`
  mutation DeleteTheme($input: DeleteThemeInput!) {
    deleteTheme(input: $input) {
      ... on DeleteThemeSuccess {
        themeId
      }
      ... on DeleteThemeFailure {
        code
      }
    }
  }
`;

export const SET_DEFAULT_THEME = gql`
  mutation SetDefaultTheme($input: SetDefaultThemeInput!) {
    setDefaultTheme(input: $input) {
      ... on SetDefaultThemeSuccess {
        theme {
          ...ThemeFragment
        }
      }
      ... on SetDefaultThemeFailure {
        code
      }
    }
  }
`;
